import { makeStyles } from 'tss-react/mui';

import { isLightMode } from 'pages/Landings/utils';

export default makeStyles({ name: 'Paragraph' })((theme) => {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: 8,
            flex: '1 0 0'
        },
        primary: {
            display: 'block',
            margin: 0,
            padding: 0,
            color: isLightMode(theme) ? '#232323' : '#fff',
            fontSize: 20,
            fontWeight: isLightMode(theme) ? 500 : 600,
            lineHeight: '30px',
            letterSpacing: '-0.6px'
        },
        secondary: {
            display: 'block',
            margin: 0,
            padding: 0,
            opacity: 0.5,
            color: isLightMode(theme) ? '#232323' : '#fff',
            fontSize: 18,
            fontWeight: 400,
            lineHeight: '160%',
            ['strong']: {
                color: isLightMode(theme) ? '#232323' : '#fff',
                fontSize: 20,
                fontWeight: 600,
                lineHeight: '30px',
                letterSpacing: '-0.6px'
            }
        }
    };
});
